import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { Link } from "react-router-dom";
// Your Branch API (for fetching branch details)
const BRANCH_LIST_URL = `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`;

// Your Demo Video Logic API (for getting the video link)
const VIDEO_CONFIG_URL =
  "https://qmqfjrb26f.execute-api.ap-south-1.amazonaws.com/default/DemoVideoFun";

export default function VideoPlayerPage() {
  const auth = useAuth();
  const userEmail = auth.user?.profile?.email || "Unknown";
  const navigate = useNavigate();

  const [isFinishing, setIsFinishing] = useState(false);
  const [branchId, setBranchId] = useState(null);
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [videoView, setVideoView] = useState(false);
  const resolveData = useCallback(async () => {
    try {
      // 1. Get the User's Branch ID
      const branchRes = await fetch(BRANCH_LIST_URL);
      const branchData = await branchRes.json();
      const match = (branchData.branches || []).find(
        (b) => b.email?.toLowerCase() === userEmail.toLowerCase(),
      );
      if (match) setBranchId(match.id);
      setVideoView(match.hasViewedDemo);
      // 2. Get the Video URL from the Backend
      const videoRes = await fetch(VIDEO_CONFIG_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // ADD THIS
        },
        body: JSON.stringify({ action: "GET_VIDEO" }),
      });

      const videoData = await videoRes.json();
      if (videoData.videoUrl) {
        setVideoUrl(videoData.videoUrl);
      } else {
        window.alert("No vido Found");
        console.error("No video URL found in backend config.");
      }
    } catch (err) {
      console.error("Error fetching data from backend:", err);
    } finally {
      setLoading(false);
    }
  }, [userEmail]);

  useEffect(() => {
    resolveData();
  }, [resolveData]);

  const handleVideoEnded = async () => {
    if (!branchId)
      return alert("Branch ID not resolved. Cannot save progress.");

    setIsFinishing(true);
    try {
      // Use your createBranch API with the PATCH method we created earlier
      const res = await fetch(BRANCH_LIST_URL, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: branchId,
          hasViewedDemo: true,
        }),
      });

      if (res.ok) {
        navigate("/"); // Move to dashboard
      } else {
        throw new Error("Failed to update status");
      }
    } catch (err) {
      console.error(err);
      alert("Error saving progress. Please try refreshing.");
    } finally {
      setIsFinishing(false);
    }
  };

  if (loading)
    return <div className="full-page-player">Loading Training Module...</div>;

  return (
    <>
      {!videoView ? (
        <>
          <div className="full-page-player">
            <div className="player-container">
              {videoUrl ? (
                <>
                  <div className="player-info">
                    <h2>Training Module</h2>{" "}
                    <Link to="/">
                      <button className="br-btn">Back</button>
                    </Link>
                    <p>Please watch the full video to proceed.</p>
                  </div>
                  <video
                    onEnded={handleVideoEnded}
                    controls
                    controlsList="nodownload"
                    autoPlay
                    className="main-video"
                  >
                    <source src={videoUrl} type="video/mp4" />
                  </video>
                </>
              ) : (
                <div className="no-video-state">
                  <h2>Video Not Found</h2>
                  <p>The admin hasn't published a training video yet.</p>
                  <button onClick={() => navigate("/")}>Go to Dashboard</button>
                </div>
              )}
              {isFinishing && (
                <div className="overlay-msg">
                  Verifying completion and unlocking dashboard...
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="full-page-player">
            <div className="player-container">
              <h2>No Access</h2>
              <p>Contact Admin to see the video</p>
              <Link to="/">
                <button className="br-btn">Back</button>
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
}
